module.exports = __webpack_public_path__ + "img/505.c5145d54.png";